import React, { useState } from 'react';
import { MonthCalendar } from '../components/calendar/MonthCalendar';
import { JournalPage } from './JournalPage';
export function CalendarPage() {
  const [selected, setSelected] = useState<string | null>(null);
  if (selected) {
    return <JournalPage date={selected} onBack={() => setSelected(null)} onChangeDate={setSelected} data-id="element-652" data-mp="3imfmt7w8c9uj" />;
  }
  return <div style={{
    width: '100%',
    maxWidth: 'none',
    minWidth: 0
  }} data-id="element-653" data-mp="3nl9132jcc4vr">
      <MonthCalendar selected={selected} onSelect={setSelected} data-id="element-654" data-mp="f44hyr7avrp6" />
    </div>;
}